export default __webpack_public_path__ + "static/media/logo-new.4850a875.png";